import * as constants from './constants';

export const getManufacturers = (payload) => ({ type: constants.GET_MANUFACTURERS, payload });
export const getManufacturersSuccess = (payload) => ({
  type: constants.GET_MANUFACTURERS_SUCCESS,
  payload,
});
export const getManufacturerssError = (payload) => ({
  type: constants.GET_MANUFACTURERS_ERROR,
  payload,
});

export const resetManufacturers = () => ({ type: constants.RESET_MANUFACTURERS });
